import { isoUtcWallClock, utcTodayYmd, ymdFromUnknown } from './wallClock';
import { parseItemTimeToHHmm } from './itemTime';

/** YYYY-MM-DD for local calendar today (non-cruise / device calendar). */
export function localTodayYmd(now = new Date()): string {
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, '0');
  const d = String(now.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

/**
 * True when the visit/day ended before today on the itinerary (UTC civil) calendar.
 * Mirrors iOS cruise day comparisons that use NaiveWallClockDateParser.localCalendar.
 */
export function isPastVisitDate(
  departureDate: string | null | undefined,
  arrivalDate: string | null | undefined,
  now = new Date()
): boolean {
  const end = ymdFromUnknown(departureDate) ?? ymdFromUnknown(arrivalDate);
  if (!end) return false;
  return end < utcTodayYmd(now);
}

/**
 * True when an itinerary item's wall-clock start is still in the future
 * (or has no time). Used for collapsePastItems — compares the UTC civil
 * instant (iOS startTime Date) to `now`, not the browser local clock.
 */
export function isItemStillUpcoming(
  dayDate: string | null | undefined,
  timeHm: string | null | undefined,
  now = new Date()
): boolean {
  const day = ymdFromUnknown(dayDate);
  if (!day) return true;
  const hm = parseItemTimeToHHmm(timeHm);
  if (!hm) {
    // No clock time: still upcoming if the catalog day is not before UTC today.
    return day >= utcTodayYmd(now);
  }
  const iso = isoUtcWallClock(day, hm);
  const startMs = Date.parse(iso);
  if (!Number.isFinite(startMs)) return true;
  return startMs >= now.getTime();
}
